export default "/directory/static/drone_available.592c34ef.svg";